import { useFormContext } from 'react-hook-form';
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from '@/components/ui/form';
import { Input } from '../ui/input';
import { HTMLInputTypeAttribute } from 'react';
import { ReactElement } from 'react';

interface Props {
    className?: string;
    value?: number;
    name: string;
    label?: string;
    placeholder?: string;
    type?: HTMLInputTypeAttribute;
    disabled?: boolean;
    icon?: ReactElement; // Optional icon prop
    iconPosition?: 'left' | 'right'; // Optional prop to control icon position
     endAdornment?: ReactElement; 
}

export default function TextInputForm({
    className,
    value,
    name,
    label,
    placeholder,
    type,
    disabled = false,
    icon,
    iconPosition = 'right',
    endAdornment,
}: Props) {
    const { control } = useFormContext();

    const handleWheel = (e: React.WheelEvent<HTMLInputElement>) => {
        if (type === 'number') {
            e.currentTarget.blur();
        }
    };

    return (
        <FormField
            control={control}
            name={name}
            render={({ field }) => (
                <FormItem className={className}>
                    {label && (
                        <FormLabel className="text-primery-blue-900 font-medium md:text-[18px] text-[16px]">
                            {label}
                        </FormLabel>
                    )}

                    <FormControl>
                        <div className="relative">
                            {icon && (
                                <div
                                    className={`absolute inset-y-0 ${
                                        iconPosition === 'left' ? 'left-3' : 'right-3'
                                    } flex items-center pointer-events-none`}
                                >
                                    {icon}
                                </div>
                            )}

                            {endAdornment && (
                                <div className="absolute inset-y-0 left-3 flex items-center">
                                    {endAdornment}
                                </div>
                            )}

                            <Input
                                {...field}
                                type={type}
                                placeholder={placeholder}
                                onWheel={handleWheel}
                                disabled={disabled}
                                className={`placeholder:text-white-blue-600 ${
                                    icon ? (iconPosition === 'left' ? 'pl-10' : 'pr-10') : ''
                                } ${endAdornment ? 'pl-10' : ''}`}
                            />
                        </div>
                    </FormControl>

                    <FormMessage />
                </FormItem>
            )}
        />
    );
}